import React from 'react';
import { BsGeo, BsPeople, BsStar } from 'react-icons/bs';
import { TiFlowChildren } from 'react-icons/ti';

import { analyticsIds } from '../../../../constants/analyticsIds';
import { Statuses } from '../../../../constants/statuses';

import InsuredAddress from './InsuredContactInfoComponents/InsuredAddress';
import InsuredContact from './InsuredContactInfoComponents/InsuredContact';
import InsuredInfo from './InsuredContactInfoComponents/InsuredInfo';
import ParentInsuredInfo from './InsuredContactInfoComponents/ParentInsuredInfo';

const overallStatusOptions = {
  [Statuses.Approved]: {
    bgColor: 'success.primary.600',
    text: 'APPROVED'
  },
  [Statuses.NotApproved]: {
    bgColor: 'error.primary.600',
    text: 'NOT APPROVED'
  },
  [Statuses.Archived]: {
    bgColor: 'greyScale.800',
    text: 'ARCHIVED'
  }
};

export const getInsuredOverallStatusOptions = status => {
  if (!status) {
    return null;
  }

  return overallStatusOptions[status];
};

const parentMenuOption = {
  menuId: 4,
  selected: false,
  icon: TiFlowChildren,
  menuText: 'Parent Insured Info',
  component: onClose => <ParentInsuredInfo onClose={onClose} />
};

export const insuredProfileModalMenuOptions = (insured, useFormMethods, onSubmit) => {
  if (!insured) return [];

  const {
    parent,
    insuredId
  } = insured;

  const modalMenu = {
    hideSideBarIcon: false,
    sideBarIconBackgroundColor: 'primaryScale.400',
    sideBarIconColor: 'white',
    currentMenuId: 1,
    menuOptions: [
      {
        menuId: 1,
        selected: true,
        icon: BsStar,
        menuText: 'Insured Info',
        dataAnalyticsId: analyticsIds.insuredProfilePage.insuredDetailsModal.insuredInfoTab,
        component: onClose => (
          <InsuredInfo
            insuredId={insuredId}
            useFormMethods={useFormMethods}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        )
      },
      {
        menuId: 2,
        selected: false,
        icon: BsGeo,
        menuText: 'Insured Address',
        dataAnalyticsId: analyticsIds.insuredProfilePage.insuredDetailsModal.insuredAddressTab,
        component: onClose => (
          <InsuredAddress
            insuredId={insuredId}
            useFormMethods={useFormMethods}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        )
      },
      {
        menuId: 3,
        selected: false,
        icon: BsPeople,
        menuText: 'Insured Contact',
        dataAnalyticsId: analyticsIds.insuredProfilePage.insuredDetailsModal.insuredContactTab,
        component: onClose => (
          <InsuredContact
            insuredId={insuredId}
            useFormMethods={useFormMethods}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        )
      }
    ]
  };

  if (parent) modalMenu.menuOptions = [...modalMenu.menuOptions, parentMenuOption];
  return modalMenu;
};
